import React from 'react'

//contexts
import { useFinanceContext } from '../../../../../_contexts/FinananceContex'
import { useAuthContext } from '../../../../../_contexts/AuthContext'

function Filter(props) {
    const financeContext = useFinanceContext()
    const auth = useAuthContext()
    const isForeman = auth.user.data.role_id == 2
    const data = props.data
    const handleFilter = e => {
        let name = e.target.name
        let val = e.target.value
        isForeman && props.handleFail(val)
        props.handleFilter(name, val)
    }
    return (
        <form
            autoComplete="off"
            role="presentation"
            className="filter-standard"
            style={{
                flexDirection: 'initial',
                flexWrap: 'wrap',
            }}
        >
            <div className="row">
                <div className="col">
                    <label htmlFor="project_id">
                        Проект
                    </label>
                    <select
                        id="project_id"
                        name="project_id"
                        onChange={handleFilter}
                    >
                        {auth.user.data.role_id != 2 && <option value="">Всички</option>}
                        {financeContext.projects.map(project =>
                            <option key={project.id} value={project.id}>
                                {project.name}
                            </option>
                        )}
                    </select>
                </div>

                <div className="col">
                    <label htmlFor="fromdate">
                        От
                    </label>
                    <input
                        type="date"
                        onChange={handleFilter}
                        name="fromdate"
                        id="fromdate"
                    />
                </div>
                <div className="col">
                    <label htmlFor="todate">
                        До
                    </label>
                    <input
                        type="date"
                        onChange={handleFilter}
                        name="todate"
                        id="todate"
                    />
                </div>

                {!isForeman && <div className="col">
                    <label htmlFor="user_id">
                        Бригадир
                    </label>
                    <select
                        id="user_id"
                        name="user_id"
                        onChange={handleFilter}
                    >
                        <option value="">Всички</option>
                        {financeContext.data.foreman && financeContext.data.foreman.map(fore =>
                            <option key={fore.id} value={fore.id}>
                                {fore.name}
                            </option>
                        )}
                    </select>
                </div>}
                <div className="col">
                    <label htmlFor="payment_type_id">
                        Вид плащане
                    </label>
                    <select
                        id="payment_type_id"
                        name="payment_type_id"
                        onChange={handleFilter}
                        value={data.payment_type_id}
                    >
                        <option value={0}>Всички</option>
                        {financeContext.paymentTypes.filter(c => (isForeman && c.id != 1) || (!isForeman && c)).map(type =>
                            <option key={type.id} value={type.id}>
                                {type.name}
                            </option>
                        )}
                    </select>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <label htmlFor="expense_id">
                        Тип Разход
                    </label>
                    <select
                        id="expense_id"
                        name="expense_id"
                        onChange={handleFilter}
                    >
                        <option value="">Всички</option>
                        {financeContext.data.expense_type && financeContext.data.expense_type.map(exp =>
                            <option key={exp.id} value={exp.id}>
                                {exp.name}
                            </option>
                        )}
                    </select>
                </div>

                <div className="col">
                    <label htmlFor="name">
                        Търсене
                    </label>
                    <input
                        type="search"
                        placeholder="Въведете име"
                        onChange={handleFilter}
                        name="name"
                        id="name"
                    />
                </div>
            </div>
        </form>
    )
}

export default Filter